import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { TripDetailProps } from '../api/response';

export const useTripDetailQuery = ({ tripId }: { tripId?: string }) => {
  const axios = useAxios();

  const handleFetch = () => axios.get<AxiosResponse<TripDetailProps>>(`${ApiRoutes.tripDetail}/${tripId}`);

  // const handleFetch = () => {
  // return axios.get<AxiosResponse<TripDetailProps>>(ApiRoutes.tripDetail);
  //   return camelizeKeys({
  //     data: {
  //       data: {
  //         route_id: '12DA',
  //         departure_date: '2022-10-05',
  //         departure_time: '07:30 AM',
  //         duration: '4h 30m',
  //         price: 12,
  //         fare_id: '61SA',
  //         trip_info:
  //           'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.',
  //         from_location: {
  //           id: '12XS',
  //           name: 'Phnom Penh',
  //           abbreviation: 'PP',
  //           slug: 'phnom_penh',
  //         },
  //         to_location: {
  //           id: '11XZ',
  //           name: 'Siem Reap',
  //           abbreviation: 'SR',
  //           slug: 'siem_reap',
  //         },
  //         amenities: [
  //           {
  //             icon: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
  //             label: 'Wi-Fi',
  //           },
  //           {
  //             icon: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
  //             label: 'Water',
  //           },
  //         ],
  //         vehicle: {
  //           name: 'Bus',
  //           image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
  //         },
  //         vehicle_galleries: [
  //           {
  //             image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
  //             alt: 'Lorem ipsum dolor sit amet',
  //           },
  //           {
  //             image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
  //             alt: 'Lorem ipsum dolor sit amet',
  //           },
  //           {
  //             image: 'https://imagery.go24.tech/media/upload/ServiceCategories/food_20190830172639.png?w=60&fm=webp',
  //             alt: 'Lorem ipsum dolor sit amet',
  //           },
  //         ],
  //         transits: [
  //           {
  //             province: 'Phnom Penh',
  //             station_name: 'Nham24 Phnom Penh branch',
  //             sequence: 0,
  //             address:
  //               '28 Street 63 Phnom Penh, Cambodia Lorem ipsum dolor sit amet, consectetuer adipiscing elitdsgfw...',
  //             latitude: 11.402423872038888,
  //             longitude: 104.86387505238194,
  //           },
  //           {
  //             province: 'Siem ',
  //             station_name: 'Nham24 Siem Reap branch',
  //             sequence: 1,
  //             address:
  //               '28 Street 63 Phnom Penh, Cambodia Lorem ipsum dolor sit amet, consectetuer adipiscing elitdsgfw...',
  //             latitude: 11.402423872038888,
  //             longitude: 104.86387505238194,
  //           },
  //         ],
  //       },
  //     },
  //   });
  // };

  return useQuery(['trip-details', tripId], handleFetch, {
    select: (res: any) => {
      return res.data.data;
    },
    keepPreviousData: true,
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: USE_QUERY_CONSTANTS.refetchOnWindowFocus,
    retry: USE_QUERY_CONSTANTS.retry,
  });
};
